import { data, type ObservableValue } from '@amazon/vinyl-observable'

const MAX_HISTORY = 12
const KEY = 'search:history'

function loadInitial(): readonly string[] {
    try {
        if (typeof localStorage === 'undefined') return []
        const raw = localStorage.getItem(KEY)
        if (!raw) return []
        const parsed: unknown = JSON.parse(raw)
        if (!Array.isArray(parsed)) return []
        return parsed.filter((v): v is string => typeof v === 'string').slice(0, MAX_HISTORY)
    } catch {
        return []
    }
}

const history = data(loadInitial())

function persist(value: readonly string[]): void {
    try {
        if (typeof localStorage === 'undefined') return
        localStorage.setItem(KEY, JSON.stringify(value))
    } catch {
        // localStorage can throw under quota / private-browsing — ignore.
    }
}

/**
 * Returns an observable list of recent search queries (newest first).
 * Mirrors GH's SearchHistory pattern: the list is shown when the
 * search input is empty so users can re-run a previous query.
 */
export function getSearchHistory(): ObservableValue<readonly string[]> {
    return history
}

export function recordSearchQuery(query: string): void {
    const trimmed = query.trim()
    if (!trimmed) return
    const filtered = history.value.filter(
        (q) => q.toLocaleLowerCase() !== trimmed.toLocaleLowerCase()
    )
    const next = [trimmed, ...filtered].slice(0, MAX_HISTORY)
    history.value = next
    persist(next)
}

export function clearSearchHistory(): void {
    history.value = []
    persist([])
}
